import { EyeOutlined } from '@ant-design/icons';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Image, Text } from '..';

export const IMAGE_PREVIEW_BUTTON_DEFAULT_WIDTH = 80;

type Props = {
  previewURL: string | undefined | null;
  borderRadius?: number;
  width?: number;
  height?: number;
};

export const ImagePreviewButton: FC<Props> = ({
  previewURL,
  borderRadius,
  width = IMAGE_PREVIEW_BUTTON_DEFAULT_WIDTH,
  height = 20,
}) => {
  const { t } = useTranslation();
  const [hover, setHover] = useState(false);

  return (
    <div
      style={{
        width,
        height,
        position: 'relative',
        backgroundColor: hover ? 'rgba(0, 0, 0, 0.06)' : undefined,
        borderRadius,
      }}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      <Flex
        gap={4}
        align="center"
        justify="center"
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <EyeOutlined style={{ fontSize: '16px' }} />
        <Text text={t('preview')} weight="regular" variant="footnote" />
      </Flex>
      <Box cursor="pointer" position="absolute" top={0} left={0}>
        <Image
          width={width}
          height={height}
          style={{ visibility: 'hidden' }}
          preview={{ mask: false, src: previewURL ?? undefined }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      </Box>
    </div>
  );
};
